/* global PUBLIC_PATH BUILD_TYPE */
export const workerUrl = `${PUBLIC_PATH}js/${BUILD_TYPE === 'legacy' ? 'legacy' : 'modern'}/room-v5.named-worker.js`;
